import React, { FC } from "react";

import AdGroupsCreativesDashboard from "../AdvertiserDetailPage/CampaignsDashboard/components/AdGroupsCreativesDashboard/AdGroupsCreativesDashboard";
import BeeswaxReportsTable from "../AdvertiserDetailPage/CampaignsDashboard/components/LineItemsReportSectionComponents/BeeswaxReportsTable";
import CampaignLineItemsReportDashboard from "../AdvertiserDetailPage/CampaignsDashboard/components/LineItemsReportSectionComponents/CampaignLineItemsReportDashboard";
import CampaignReportDashboard from "../AdvertiserDetailPage/CampaignsDashboard/components/CampaignReportSectionComponents/CampaignReportDashboard";
import CampaignReportDashboardToolbar from "../AdvertiserDetailPage/CampaignsDashboard/components/CampaignReportSectionComponents/CampaignReportDashboardToolbar";
import CampaignTargetingSelectionsDashboard from "../AdvertiserDetailPage/CampaignsDashboard/components/CampaignTargetingSelectionsComponents/CampaignTargetingSelectionsDashboard";
import SiteReportsTable from "../AdvertiserDetailPage/CampaignsDashboard/components/LineItemsReportSectionComponents/SiteReportsTable";
import { BrandgenCampaignPool, BrandgenCampaignPoolReport, ReportTimeFrames } from "../../types/campaignTypes";
import { useCampaignDashboardStyles } from "../AdvertiserDetailPage/CampaignsDashboard/CampaignDashboardStylesContext";

type CampaignDetailDashboardProps = {
  selectedCampaignPool: BrandgenCampaignPool;
  selectedTimeFrame: ReportTimeFrames;
  handleTimeFrameChange: (e: any) => void;
  fetchAndSetCampaign: () => void;
  selectedCampaignPoolReport: BrandgenCampaignPoolReport | null;
  customReportDate: Date | undefined;
  isFetching: boolean;
  isCustomDateChanged: boolean;
};

const CampaignDetailDashboard: FC<CampaignDetailDashboardProps> = ({
  selectedCampaignPool,
  selectedTimeFrame,
  handleTimeFrameChange,
  fetchAndSetCampaign,
  selectedCampaignPoolReport,
  customReportDate,
  isFetching,
  isCustomDateChanged,
}) => {
  const classes = useCampaignDashboardStyles();

  return (
    <div className={classes.container}>
      <div className={classes.campaignReportSection}>
        <CampaignReportDashboardToolbar
          selectedTimeFrame={selectedTimeFrame}
          handleTimeFrameChange={handleTimeFrameChange}
          selectedCampaignPool={selectedCampaignPool}
          fetchAndSetCampaigns={fetchAndSetCampaign}
          hideCampaignSelector
        />
        {!isFetching && (
          <CampaignReportDashboard
            campaignPoolReport={selectedCampaignPoolReport}
            campaign={selectedCampaignPool}
            selectedTimeFrame={selectedTimeFrame}
          />
        )}
      </div>

      <div className={classes.campaignsLineItemsReportSection}>
        <CampaignLineItemsReportDashboard
          selectedTimeFrame={selectedTimeFrame}
          campaign={selectedCampaignPool}
          customReportDate={customReportDate}
          isCustomDateChanged={isCustomDateChanged}
        />
      </div>

      <SiteReportsTable selectedTimeFrame={selectedTimeFrame} campaign={selectedCampaignPool} />

      <BeeswaxReportsTable selectedTimeFrame={selectedTimeFrame} campaign={selectedCampaignPool} />

      <div className={classes.campaignsTargetingInfoSection}>
        <CampaignTargetingSelectionsDashboard campaign={selectedCampaignPool} />
      </div>

      <div className={classes.adGroupsDashboard}>
        <AdGroupsCreativesDashboard
          selectedTimeFrame={selectedTimeFrame}
          selectedCampaign={selectedCampaignPool}
          customReportDate={customReportDate}
          isCustomDateChanged={isCustomDateChanged}
        />
      </div>
    </div>
  );
};

export default CampaignDetailDashboard;
